import { profileUrl } from '../api/tmdb'
import { IconSwords, IconClapper } from './icons'

const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='185' height='278' viewBox='0 0 185 278'%3E%3Crect fill='%23333' width='185' height='278'/%3E%3Ccircle fill='%23555' cx='92' cy='100' r='40'/%3E%3Cellipse fill='%23555' cx='92' cy='220' rx='60' ry='50'/%3E%3C/svg%3E"

function ActorCard({ actor, label }) {
  return (
    <div className="h2h-reveal__actor">
      <span className="h2h-reveal__actor-label">{label}</span>
      <img
        src={actor?.profile_path ? profileUrl(actor.profile_path, 'w185') : PLACEHOLDER}
        alt={actor?.name || '?'}
        className="h2h-reveal__actor-img"
        onError={(e) => { e.target.src = PLACEHOLDER }}
      />
      <span className="h2h-reveal__actor-name">{actor?.name || '—'}</span>
    </div>
  )
}

export default function H2HReveal({ challenge, myRole, onStartPlaying }) {
  const startActor = challenge.p2StartActor
  const goal = challenge.goalActor

  return (
    <div className="h2h-reveal">
      <p className="h2h-reveal__title">Game On! <IconSwords size={20} style={{ verticalAlign: 'middle' }} /></p>
      <p className="h2h-reveal__sub">May the best chain win <IconClapper size={15} style={{ verticalAlign: 'middle' }} /></p>

      <div className="h2h-reveal__matchup">
        <ActorCard actor={startActor} label="START" />
        <div className="h2h-reveal__vs"><IconSwords size={28} /></div>
        <ActorCard actor={goal} label="GOAL" />
      </div>

      {onStartPlaying && (
        <button className="btn-primary h2h-reveal__start" onClick={onStartPlaying}>
          Start Playing <IconClapper size={15} style={{ verticalAlign: 'middle' }} />
        </button>
      )}
    </div>
  )
}
